import React from 'react'
import { useActions, useValues } from 'kea'
// eslint-disable-next-line import/no-named-as-default
import ReCAPTCHA from 'react-google-recaptcha'
import { isValidPhoneNumber } from 'react-phone-number-input'
import { useSelector } from 'react-redux'
import ReactHtmlParser from 'react-html-parser'

import I18n from 'lib/i18n'
import PhoneNumber from 'lib/forms/phone-number'
import SubmitButton from 'lib/tags/submit-button'
import Spinner from 'lib/tags/spinner'
import DateStringSelect from 'lib/forms/date-string-select'
import railsContext from 'lib/selectors/rails-context'
import BreakOnBr from 'lib/tags/break-on-br'

import { form, Field } from './form'

import logic from '../logic'

const Form = () => {
  const { setGrecaptchaObject } = useActions(logic)
  const { submit, setValue } = useActions(form)
  const { redirecting, oauthRegistration, needBirthday, recaptchaSiteKey, skipRecaptcha, isEmailOnly, notice } =
    useValues(logic)
  const { hasChanges, hasErrors, isSubmitting, isValidating, values, errors } = useValues(form)
  const { sessionCountry } = useSelector(railsContext)

  return (
    <div className='signup-methods' data-attr='signup-form'>
      {isEmailOnly && (
        <h6>
          <BreakOnBr text={notice} />
        </h6>
      )}

      {oauthRegistration && <h6>{I18n.t('devise.registrations.omniauth_data_missing')}</h6>}

      <Field name='name' label={I18n.t('devise.registrations.new.full_name_placeholder')}>
        {({ value, setTargetValue }) => (
          <input
            type='text'
            data-attr='name'
            value={value}
            onChange={setTargetValue}
            className='input-text inline'
            maxLength={140}
          />
        )}
      </Field>

      {needBirthday && (
        <Field name='birthday' label={I18n.t('devise.registrations.new.modal_birthday')}>
          {({ value, setValue }) => <DateStringSelect allowBlank dateString={value} onChange={setValue} />}
        </Field>
      )}

      <Field name='phone' label={I18n.t('snippets.phone_image.placeholder')} errorHTML>
        {({ value }) => (
          <div className='position-relative'>
            <PhoneNumber
              data-attr='phone'
              value={value}
              defaultCountry={sessionCountry}
              onBlurTrigger={false}
              onChange={phone => {
                setValue('phoneValid', isValidPhoneNumber(phone))
                setValue('phone', phone)
              }}
              onFlagSelect={phone => {
                setValue('phoneValid', isValidPhoneNumber(phone))
              }}
            />
            {isValidating === 'phone' && <Spinner style={{ position: 'absolute', right: 3, top: 5 }} />}
          </div>
        )}
      </Field>

      <Field name='email' label={I18n.t('activerecord.attributes.user.email')} errorHTML>
        {({ value, setTargetValue }) => (
          <div className='position-relative'>
            <input
              type='email'
              data-attr='email'
              value={value}
              onChange={setTargetValue}
              className='input-text inline'
              maxLength={140}
            />
            {isValidating === 'email' && <Spinner style={{ position: 'absolute', right: 3, top: 5 }} />}
          </div>
        )}
      </Field>

      {!oauthRegistration && (
        <Field name='password' label={I18n.t('devise.registrations.new.password_modal')}>
          {({ value, setTargetValue }) => (
            <input
              type='password'
              data-attr='password'
              value={value}
              onChange={setTargetValue}
              className='input-text inline'
              maxLength={140}
            />
          )}
        </Field>
      )}

      <div className='terms-row'>
        {ReactHtmlParser(
          I18n.t('devise.registrations.new.terms_line', {
            terms_link: `<a href='/terms' target='_blank'>${I18n.t('devise.registrations.new.terms_link')}</a>`
          })
        )}
      </div>

      {!skipRecaptcha && (
        <Field name='token' onlyField='true'>
          {({ _, setValue }) => (
            <ReCAPTCHA
              sitekey={recaptchaSiteKey}
              onChange={token => {
                setValue(token)
              }}
              asyncScriptOnLoad={() => {
                if (typeof window !== 'undefined') {
                  setGrecaptchaObject(window.grecaptcha.enterprise)
                }
              }}
            />
          )}
        </Field>
      )}

      {errors.token && values.token ? (
        <div className='simple-error'>{I18n.t('courses.form.error_field_empty')}</div>
      ) : null}

      <SubmitButton
        isSubmitting={isSubmitting || redirecting}
        isButtonHaveDisabledStyle={!redirecting && (hasErrors || !hasChanges)}
        onClick={submit}
        data-attr='submit-signup'
        style={{
          padding: '10px 20px',
          borderRadius: '3px',
          fontWeight: 'bold',
          fontSize: '15px',
          marginTop: '10px'
        }}
      >
        {I18n.t('devise.registrations.new.sign_up')}
      </SubmitButton>
    </div>
  )
}

export default Form
